import {
  Component,
  Input,
  ViewChild,
  OnInit,
  ViewContainerRef,
  OnDestroy,
} from "@angular/core";
import { SubSink } from "subsink";

import { ZoneComponent } from "@/shared-module/components";
import { ConfigurationService } from "@/shared-module/services";
import { Configuration, RankDatasource } from "@/shared-module/models";

@Component({ selector: "app-rank", templateUrl: "rank.component.html" })
export class RankComponent implements OnInit, ZoneComponent, OnDestroy {
  @Input() data: RankDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @Input() set cssColor(cssColor: string) {
    if (cssColor) {
      this.cssColorInv = cssColor + "-inv";
    }
  }
  cssColorInv: string;
  logoImage: string;
  @ViewChild("template", { static: true }) template;
  subs = new SubSink();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        if (c.highContrast) {
          thisObject.logoImage = `img/${c.cssColor}-cup-hc.svg`;
        } else {
          thisObject.logoImage = `img/${c.cssColor}-cup.svg`;
        }
      },
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  formatDate(d: any) {
    if (!d) {
      return null;
    }
    const date = new Date(d + "Z");

    return (
      date.getDate() +
      "/" +
      (date.getMonth() + 1) +
      "/" +
      date.getFullYear() +
      " " +
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
      ":" +
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes())
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
